import { Button } from "@volca/ui/components/ui/button";
import {
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import {
  Popover,
  PopoverContent,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from "@volca/ui/components/ui/popover";
import { Text } from "@volca/ui/components/ui/text";

export const ReferralSourcesEmptyState = () => (
  <>
    <EmptyHeader>
      <EmptyDescription>No referral sources set up yet.</EmptyDescription>
    </EmptyHeader>
    <EmptyContent>
      <Popover>
        <PopoverTrigger
          render={
            <Button
              variant="link"
              className="h-auto p-0 font-normal underline"
            />
          }
        >
          What is a referral source?
        </PopoverTrigger>
        <PopoverContent className="w-80 gap-4 p-4 text-left">
          <PopoverHeader>
            <PopoverTitle>Referral sources</PopoverTitle>
          </PopoverHeader>
          <Text>
            A <strong>referral source</strong> is a way to get an attribution
            code that is not linked to a user. Have a promotion you are running?
            Want a code for a specific event where you have someone getting
            signups for your program?
          </Text>
          <Text>
            Click <strong>Add source</strong> at the top of the page. There you
            can name and describe whatever signup source you want to track
            independently.
          </Text>
        </PopoverContent>
      </Popover>
    </EmptyContent>
  </>
);
